import React, { FC, Dispatch, SetStateAction, useEffect, useRef } from "react";
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  Keyboard,
  TouchableOpacity,
  Platform,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  input: {
    width: 40,
    height: 40,
    textAlign: "center",
    borderWidth: 1,
    borderColor: "#00000030",
    fontSize: 20,
  },
  focusedInput: {
    borderColor: "#000",
  },
});

type OTPInputWebProps = {
  code: any | undefined;
  setCode: Dispatch<SetStateAction<string>>;
  maximumLength: number;
  onOtpCompleted?: () => void;
  error: boolean;
  errorTitle: string;
};

const OTPInputWeb: FC<OTPInputWebProps> = ({
  code,
  setCode,
  maximumLength,
  onOtpCompleted,
  error = false,
  errorTitle,
}) => {
  const navigation = useNavigation();
  const inputRefs = useRef<Array<TextInput | null>>(
    Array(maximumLength).fill(null)
  );

  useEffect(() => {
    if (code.length === maximumLength && onOtpCompleted && code[5] !== "") {
      onOtpCompleted();
    }
  }, [code, navigation]);

  const handleInputChange = (index: number, value: string) => {
    const newCode: any = [...code];
    newCode[index] = value;
    for (let i = index + 1; i < maximumLength; i++) {
      newCode[i] = "";
    }
    setCode(newCode);

    if (value && index < maximumLength - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleInputFocus = (index: number) => {
    inputRefs.current.forEach((ref, i) => {
      if (i !== index && ref) {
        ref.blur();
      }
    });
  };

  return (
    <View style={styles.container}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {Array(maximumLength)
          .fill(null)
          .map((_, index) => (
            <TouchableOpacity
              key={index}
              activeOpacity={1}
              onPress={() => {
                inputRefs.current[index]?.focus();
                handleInputFocus(index);
              }}
            >
              <TextInput
                ref={(ref) => (inputRefs.current[index] = ref)}
                style={[
                  styles.input,
                  error && { borderColor: "red" },
                  index === maximumLength - 1 && { marginRight: 0 },
                ]}
                value={code[index]}
                onChangeText={(value) => handleInputChange(index, value)}
                keyboardType="number-pad"
                maxLength={1}
                autoFocus={index === 0}
                onFocus={() => handleInputFocus(index)}
                onBlur={() => inputRefs.current[index]?.blur()}
                onSubmitEditing={() => Keyboard.dismiss()}
                onKeyPress={({ nativeEvent }) => {
                  if (nativeEvent.key === "Backspace" && index > 0  && !code[index] ) {
                    inputRefs.current[index - 1]?.focus();
                  }
                }}
              />
            </TouchableOpacity>
          ))}
      </View>
      {error && (
        <CustomComponent.TextView
          title={errorTitle}
          textStyle={[GlobalStyles.bodyText, { color: Colors.red10 }]}
          boxStyle={{ paddingVertical: 10 }}
        />
      )}
    </View>
  );
};

export default OTPInputWeb;